import styled from "styled-components";
export const ListContainer = styled.section`
  padding: 32px 0;
  .type-selector {
    display: flex;
    .item {
      width: 50%;
      text-align: center;
      background: #fff;
      font-size: ${({ theme }) => theme.sizes.font3};
      padding: 28px 0 24px 0;
      cursor: pointer;
      &:first-child {
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
      }
      &:last-child {
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
      }
    }
    .active {
      background: ${({ theme }) => theme.colors.btnPrimaryBg};
      color: #fff;
      cursor: default;
    }
  }
`;
